export const blogPostEndpoints = [
  '/blog/posts/15-must-attend-moto-shows-in-2023-everything-you-need-to-know',
  '/blog/posts/15-must-attend-moto-shows-in-2022-everything-you-need-to-know',
]